import styled from 'styled-components'

export const StyledRating = styled.div`
  display: flex;
  align-items: end;
  padding: 2px;
  width: fit-content;
`
